import setValue from 'js/components/shared/actions/setValue'

export default keyword => dispatch => dispatch(setValue('holdKeyword', keyword))
